<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
            style="font-size: 20px;"
            large
            @click.stop="open = !open"
            v-bind="attrs"
            v-on="on"
            color="primary">mdi-dots-vertical</v-icon>
      </template>
      <v-list v-model="open">
        <div v-for="(action, index) in actions" :key="index">
          <v-divider v-if="action.dividerBefore"/>
          <v-list-item
              style="cursor: pointer;"
              :disabled="action.disabled"
              @click="action.click">
            <v-list-item-icon
                style="margin-top: 0.75rem; margin-bottom: 0; margin-right: 1rem;">
              <v-icon>{{ action.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content style="padding-top: 0; padding-bottom: 0">
              <v-list-item-title>{{ action.label }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="action.dividerAfter"/>
        </div>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
/**
 * {
 *   icon:  mdi icon name like 'mdi-delete', optional
 *   label: label text , required
 *   click: function to call, required
 *   disabled: disables action, optional defaults to false
 *   dividerBefore: true|false. Add divider line before this action
 *   dividerAfter: true|false. Add divider line after this action
 * }
 */
import Vue from 'vue';

export default Vue.extend({
  name: 'EntityTableRowEndActionMenu',
  data: () => ({
    open: false,
  }),
  props: {
    actions: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
});
</script>

<style scoped>
.divider {
  border-top: 1px solid black;
}
</style>
